import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AppLoginComponent } from './app-login/app-login.component';
import { AuthServiceActivation } from './app-login/auth.service';
import { HomeComponent } from './home/home.component';
import { PricingComponent } from './pricing/pricing.component';
import { MeetOurInstructorsComponent } from './meet-our-instructors/meet-our-instructors.component';
import { TrialDialogComponent } from './trial-dialog/trial-dialog.component';

const routes: Routes = [
  {
    path: '',
    component: HomeComponent
  },
  {
    path: 'login',
    component: AppLoginComponent,
    canActivate: [
      AuthServiceActivation
    ]
  },
  {
    path: 'main',
    loadChildren: () => import('./main-app/main-app.module').then( m => m.MainAppModule),
  },
  {
    path: 'pricing',
    component: TrialDialogComponent
  },
  {
      path: 'meet-our-instructors',
      component: MeetOurInstructorsComponent
  },
  {
    path: 'free-trial',
    component: TrialDialogComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy'})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
